import { render, staticRenderFns } from "./IconChatAltOutline.vue?vue&type=template&id=2ac98ba9"
import script from "./IconChatAltOutline.vue?vue&type=script&lang=js"
export * from "./IconChatAltOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports